module.exports = __webpack_public_path__ + "img/function.66295285.png";